import { formatDateISO } from '@zorro/shared/formatters';
import { MonolithMethodNames, callEndpoint } from '@zorro/web/ui-utils';

import { Filter, FilterRecord } from '../Filters';

export function mapDatatableFilters<
  TColumn extends string,
  TRowDto extends FilterRecord,
  TFilter extends { filterByColumn: TColumn; filterValues: string[] },
>(filters: Filter<TRowDto>[], dateColumns?: TColumn[]) {
  return filters.map((filter) => {
    const filterByColumn = filter.type as TColumn;
    const filterValues = filter.value as string[];
    return {
      filterByColumn,
      filterValues:
        dateColumns && dateColumns.includes(filterByColumn)
          ? filterValues
              .filter((date) => date !== null)
              .map((date) => formatDateISO(date))
          : filterValues,
    };
  });
}

export async function fetchAllReportRecords<T>(
  generateReportMethod: MonolithMethodNames,
  params: string[],
  generateReportDto: T
) {
  let isFinished = false;
  let page = 1;
  const allRecords = [];

  while (!isFinished) {
    const { meta, data } = await callEndpoint({
      method: generateReportMethod,
      params: [...params, { ...generateReportDto, page }] as any,
    });

    allRecords.push(...data);

    isFinished = meta.lastPage <= page;
    page++;
  }

  return allRecords;
}
